import "./RUM";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import QueryProvider from "./providers/QueryProvider";
import { Amplify } from "@aws-amplify/core";
import API from "@aws-amplify/api";
import { Auth } from "@aws-amplify/auth";
import config from "./aws-exports";
import { CURRENT_VERSION } from "./cred";
import { purgeData } from "./utils";
import { authService } from "./api/apiActions";
import { DataStore } from "@aws-amplify/datastore";
import "./index.css";

Amplify.configure({
    ...config,
    oauth: {
        ...config.oauth,
        redirectSignIn: window.location.origin,
        redirectSignOut: window.location.origin,
    },
});
Amplify.register(Auth);
Amplify.register(API);
DataStore.start();

localStorage.removeItem("registration");

/**
 * Log user out of every window, refresh the data, and redirect to landing page
 */
const storageChange = (event) => {
    const status = localStorage.getItem("logged_in");
    const id = localStorage.getItem("logged_in_id");
    if (event.key === "logged_in" && !status) {
        purgeData().finally(() => (window.location = "/"));
    } else if (event.key === "logged_in" && status) {
        window.location = `/profile/${id}`;
    }
    const installed_version = localStorage.getItem("scouted-installed-version") || "";
    if (CURRENT_VERSION !== installed_version) {
        purgeData().finally(() =>
            authService
                .isAuthenticated()
                .then(() => authService.signOut())
                .catch((e) => e),
        );
    }
    localStorage.setItem("scouted-installed-version", CURRENT_VERSION);
};

/**
 * Check the version a user is running if it is out of date force refresh
 */
const installed_version = localStorage.getItem("scouted-installed-version") || "";
if (CURRENT_VERSION !== installed_version) {
    localStorage.setItem("scouted-installed-version", CURRENT_VERSION);
    purgeData().finally(() =>
        authService
            .isAuthenticated()
            .then(() => authService.signOut())
            .catch((e) => e),
    );
}
window.addEventListener("storage", storageChange, false);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

if (rootElement.hasChildNodes()) {
    root.render(
        <QueryProvider>
            <App />
        </QueryProvider>,
    );
} else {
    root.render(
        <QueryProvider>
            <App />
        </QueryProvider>,
    );
}
